import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import {getAllAccountAPI, saveCampaignDataAPI} from "./../../../API/Admin/CampaignAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
//import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Toaster";



const CampaignAdd = () =>{

    //const [statelist, setStateList] = useState([]);
    const [accountlist, setAccountList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [txtcampaignname, setTxtCampaignname] = useState('');
    const [txtaccount, setTxtAccount] = useState('');
    const [txtpromolink, setTxtPromoLink] = useState('');
    const [txtsource, setTxtSource] = useState('');
    const navigate = useNavigate();


    useEffect(() => {

        //getStateListAPI(setStateList, setLoading);
        getAllAccountAPI(setAccountList, setLoading);


    }, []);


    const handleInputCampaignname = (event) =>{

        setTxtCampaignname(event.target.value);
    }

    const handleInputAccountID = (event) =>{
        
        setTxtAccount(event.target.value);
    }

    const handleInputPromoLink = (event) =>{
        
        setTxtPromoLink(event.target.value);
    }

    const handleInputSource = (event) =>{
        
        console.log('>>>>>>' + event.target.value);

        setTxtSource(event.target.value);
    }

    const resetUserForm = () =>{

        setTxtAccount(0);
        setTxtCampaignname("");
        setTxtPromoLink("");
        setTxtSource("");
    }

    const handleAddCampaign = () =>{

        let params = {
                    "accountid" : txtaccount,
                    "campname" : txtcampaignname,
                    "source" : txtsource,
                    "campurl" : txtpromolink                    
                };
        
        console.log('params======' + JSON.stringify(params));

        saveCampaignDataAPI(params, setLoading, resetUserForm, navigate);
    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper cardhead">
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row">
                        <div className="col">
                            <h3 className="page-title">Add New Campaign</h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">                        
                        <div className="card">                            
                            <div className="card-body">
                                <form method="post" name="frmaddcampaign" id="frmaddcampaign">
                                    <div className="mb-3">
                                        <label className="form-label">Account Name</label>
                                        <select className="form-control" name="accountname" id="accountname" value={txtaccount} onChange={handleInputAccountID}>
                                            <option value="">Select</option>
                                            {accountlist && accountlist.length > 0 ?
                                                (accountlist.map(account =>
                                                    (
                                                        <option value={account.id} key={account.id}>{account.name}</option>
                                                    )
                                                )

                                                )
                                            :
                                                <></>    
                                            }
                                            
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Campaign Name</label>
                                        <input type="text" className="form-control" name="campaignname" id="campaignname" value={txtcampaignname} onChange={handleInputCampaignname} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Landing Page URL</label>
                                        <input type="text" className="form-control" name="landingpageurl" id="landingpageurl" value={txtpromolink} onChange={handleInputPromoLink} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Source</label>
                                        <select className="form-control" name="source" id="source" value={txtsource} onChange={handleInputSource}>
                                            <option value="">Select</option>
                                            <option value="1" key="1">Google</option>
                                            <option value="2" key="2">Facebook</option>
                                        </select>
                                    </div>


                                    <div className="text-end">
										<button type="button" className="btn btn-primary"  onClick={handleAddCampaign}>
                                            {loading ?
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            :
                                                <p>Add Campaign</p>
                                            }
                                        </button>
									</div>
                                </form>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <ToastContainer />

    </div>
    )
}

export default CampaignAdd;